import React, { useState, useEffect, useContext } from "react";

import { Paper } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import { useStyles } from "./style";

import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import {
  EnhancedTableToolbar,
  CardItem,
} from "../../../components/pages/reports/refundStatement/index";

import { AccountStatementContext } from "../../../context/states/reports/accountStatementState";

const initialState = {
  isSearch: false,
  companyId: "",
  company: "",
  fromDate: null,
  toDate: null,
  businessType: "",
};

const RefundStatement = () => {
  const classes = useStyles();
  const matches = useMediaQuery("(min-width:1920px)");

  const {
    refunds,
    getRefundHandler,
    isloading,
    getClientsHandler,
    clients,
    clearStateHandler,
  } = useContext(AccountStatementContext);

  console.log("refunds", refunds);

  const [values, setValues] = useState({ ...initialState });
  const [dense] = useState(true);

  // Load Refund Statement initially
  useEffect(() => {
    getRefundHandler("");
  }, []);

  const handleChange = (event) => {
    const { name, checked, value, type } = event.target;

    setValues((prev) => ({
      ...prev,
      [name]:
        name === "businessType"
          ? checked
            ? "Private"
            : ""
          : type === "checkbox"
            ? checked
            : value,
    }));
  };

  const handleChangeAutoComplete = (name) => (event, value) => {
    if (value === null) {
      setValues({ ...initialState });
      clearStateHandler();
      return;
    }

    if (name === "company") {
      setValues((prev) => ({
        ...prev,
        company: value,
        companyId: value._id,
      }));
    }
  };

  const handleInputChange = (event) => {
    if (event.target.value === "") return;

    getClientsHandler(event.target.value);
  };

  const handleFromDateChange = (event) => {
    const date = new Date(event).toISOString();

    setValues((prev) => ({
      ...prev,
      fromDate: date,
    }));
  };

  const handleToDateChange = (event) => {
    const date = new Date(event).toISOString();

    setValues((prev) => ({
      ...prev,
      toDate: date,
    }));
  };

  const searchHandler = () => {
    setValues((prev) => ({
      ...prev,
      isSearch: true,
    }));

    let query = "?";

    if (values.companyId !== "") {
      query += `companyId=${values.companyId}`;
    }

    if (values.businessType !== "") {
      query += `${
        query.length > 1 ? "&" : ""
      }businessType=${values.businessType}`;
    }

    if (values.fromDate !== null) {
      query += `${query.length > 1 ? "&" : ""}fromDate=${values.fromDate}`;

      if (values.toDate !== null) {
        query += `&toDate=${values.toDate}`;
      }
    }

    getRefundHandler(query);
  };

  const clearSearchHandler = () => {
    setValues({ ...initialState });

    clearStateHandler();
    getRefundHandler("");
  };

  return (
    <React.Fragment>
      <div className={classes.rootM} style={{ width: "100%" }}>
        <Paper className={classes.paper}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <EnhancedTableToolbar
              handleChange={handleChange}
              values={values}
              isClients={clients}
              handleInputChange={handleInputChange}
              handleChangeAutoComplete={handleChangeAutoComplete}
              title="Refund Statement"
              handleFromDateChange={handleFromDateChange}
              handleToDateChange={handleToDateChange}
              searchHandler={searchHandler}
              clearSearchHandler={clearSearchHandler}
            />
          </MuiPickersUtilsProvider>

          <CardItem
            title="Refund Statement"
            active={classes.pendingStage}
            classes={classes}
            isLoading={isloading}
            data={refunds}
            hasData={refunds && refunds.length > 0}
            values={values}
            dense={dense}
            matches={matches}
            account={false}
            refund={true}
          />
        </Paper>
      </div>
    </React.Fragment>
  );
};

export default RefundStatement;
